export enum TransportRequestType {
    PublicTransport = 'public-transport',
    IndividualTransport = 'individual-transport',
    Refund = 'refund'
}
